export const ligasInteres = [
    {
        "ligasInteres_nombre" :"Código de ética",        
        "ligasInteres_url" : "https://periodico.hidalgo.gob.mx/?tribe_events=periodico-oficial-alcance-0-del-13-de-mayo-de-2019"
        
    },
    {
        "ligasInteres_nombre" :"Código de conducta",
        "ligasInteres_url" : "https://periodico.hidalgo.gob.mx/?tribe_events=periodico-oficial-alcance-3-del-16-de-diciembre-de-2019"
    },
    {
        "ligasInteres_nombre" :"Curriculum PIBEH",
        "ligasInteres_url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Normatividad/Curriculum.pdf"
        
    },
    {
        "ligasInteres_nombre" :"Convocatoria Personas Consejeras Protocolo Cero",
        "ligasInteres_url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Normatividad/Convocatoria0tolerancia.pdf"
        
    },
    {
        "ligasInteres_nombre" :"Directorio Personas Consejeras Protocolo Cero",
        "ligasInteres_url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Normatividad/DirectorioPersonasConsejeras.pdf"
        
    },
    {
        "ligasInteres_nombre" :"Informe de actividades CEyPCI",
        "ligasInteres_url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Normatividad/InformeAnual.pdf"
        
    },
    {
        "ligasInteres_nombre" : "Manual de Contabilidad Gubernamental de la PIBEH",
        "ligasInteres_url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Normatividad/MCG 2021.pdf"
        
    },
    {
        "ligasInteres_nombre" : "Ley de Disciplina Financiera",
        "ligasInteres_url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/AContable/LDF.pdf"
        
    },
    {
        "ligasInteres_nombre" :"Manual de Organización",
        "ligasInteres_url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Normatividad/ManualDeOrganizacion.pdf"
        
    },
    {
        "ligasInteres_nombre" :"Manual de Procedimientos",
        "ligasInteres_url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Normatividad/Manual de Procedimientos.pdf"
        
    },
    {
        "ligasInteres_nombre" :"Protocolo cero tolerancia",
        "ligasInteres_url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Normatividad/ProtocoloCeroTolerancia.pdf"
        
    },
    {
        "ligasInteres_nombre" :"Pronunciamiento cero tolerancia",
        "ligasInteres_url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Normatividad/Pronunciamiento0tolerancia.pdf"
        
    },
    {
        "ligasInteres_nombre" :"PAAAS",
        "ligasInteres_url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/transparencia/2023/PAAAS.pdf"
        
    },
    {
        "ligasInteres_nombre" :"Programa Institucional de Desarrollo 2023-2028",
        "ligasInteres_url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Normatividad/PID2023_2028.pdf"
        
    },
    {
        "ligasInteres_nombre" :"Procedimiento de denuncias",
        "ligasInteres_url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Normatividad/ProcedimientoDenunciaCEyPCI.pdf"
        
    },
    {
        "ligasInteres_nombre" :"Programa de trabajo",
        "ligasInteres_url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Normatividad/ProgramaAnual.pdf"
        
    },
    {
        "ligasInteres_nombre" :"Tabulador Salarial",
        "ligasInteres_url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Normatividad/Tabulador.pdf"
        
    },
    {
        "ligasInteres_nombre" :"Manual de Percepciones",
        "ligasInteres_url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Normatividad/Percepciones.pdf"
        
    },
    {
        "ligasInteres_nombre" :"Acta COCODI",
        "ligasInteres_url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Normatividad/COCODI.pdf"
        
    },
    {
        "ligasInteres_nombre" :"Lineamientos para el tramite a la nómina de personal exceptuado de la PIBEH",
        "ligasInteres_url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Normatividad/Lineamientos.pdf"
        
    },
    {
        "ligasInteres_nombre" :"Informe Anual de Cumplimiento del Programa de Desarrollo Archivistico",
        "ligasInteres_url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Normatividad/Informe Anual.pdf"
        
    },
    {
        "ligasInteres_nombre" :"Programa Anual de Desarrollo Archivistico (PADA)",
        "ligasInteres_url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/Normatividad/Programa Anual.pdf"
        
    },
]
